module.exports = __webpack_public_path__ + "img/pagination5-icon.32730804.png";